import { deattribute } from './deattribute';
import { linkRelationships } from './linkRelationships';

/**
 * Deserialises an array from a JSON-API structure
 *
 * @param {*} obj The response
 * @returns {Object} The deserialised response
 * @private
 */
function deserialiseArray(obj) {
  for (let value of obj.data) {
    if (obj.included) value = linkRelationships(value, obj.included);
    if (value.attributes) value = deattribute(value);
    obj.data[obj.data.indexOf(value)] = value;
  }
  return obj;
}

/**
 * Deserialises a JSON-API response
 *
 * @param {Object} obj The response
 * @returns {Object} The deserialised response
 *
 * @example <caption>Deserialise with a basic data object</caption>
 * deserialise({
 *   data: {
 *     id: '1',
 *     attributes: { liked: true }
 *   },
 *   meta: { hello: 'world' }
 * }) // { data: { id: '1', liked: true }, meta: { hello: 'world' } }
 *
 * @example <caption>Deserialise with relationships</caption>
 * deserialise({
 *   data: {
 *     id: '1',
 *     relationships: {
 *       user: {
 *         data: {
 *           type: 'users',
 *           id: '2' }
 *       }
 *     }
 *   },
 *   included: [
 *     {
 *       type: 'users',
 *       id: '2',
 *       attributes: { slug: 'wopian' }
 *     }
 *   ]
 * }) // { data: { id: '1', user: { type: 'users', id: '2', slug: 'wopian' } } }
 */
export function deserialise(obj) {
  let newObj = { ...obj };
  // Collection of resources
  // Note: constructor is currently faster than isArray()
  // http://jsben.ch/QgYAV
  if (newObj.data && newObj.data.constructor === Array) newObj = deserialiseArray(newObj);
  // Single resource with included relationships
  else if (newObj.included) newObj.data = linkRelationships(newObj.data, newObj.included);

  delete newObj.included;

  // Move attributes to the parent newObject
  if (newObj.data && newObj.data.attributes) newObj.data = deattribute(newObj.data);

  return newObj;
}
